import { render, staticRenderFns } from "./VRequestRatingModal.vue?vue&type=template&id=b16237b2"
import script from "./VRequestRatingModal.vue?vue&type=script&lang=js"
export * from "./VRequestRatingModal.vue?vue&type=script&lang=js"
import style0 from "./VRequestRatingModal.vue?vue&type=style&index=0&id=b16237b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports